import React from 'react';
import { Typography } from 'Components/atoms';

export const MicrosoftIntuneRebootConfigStep: React.FC = () => (
    <div className="action-block d-flex flex-column gap-2">
        <Typography variant="subtitle2" color="text-high-emphasis">
            Reboot Device Configuration
        </Typography>
        <Typography variant="body2" color="text-medium-emphasis">
            Triggering a Device Reboot via Intune
        </Typography>
        <Typography variant="body3" color="text-medium-emphasis">
            The credentials supplied in your <i>Intune</i> connector will be used to trigger a device reboot for the
            target device. The target device will be the Managed Device ID associated with the finding.
        </Typography>
    </div>
);
